/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CalvinUser } from './CalvinUser';
import { CalvinUserFromJSON, CalvinUserFromJSONTyped, CalvinUserToJSON } from './CalvinUser';

/**
 *
 * @export
 * @interface PaginatedCalvinUserList
 */
export interface PaginatedCalvinUserList {
  /**
   *
   * @type {number}
   * @memberof PaginatedCalvinUserList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedCalvinUserList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedCalvinUserList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<CalvinUser>}
   * @memberof PaginatedCalvinUserList
   */
  results: Array<CalvinUser>;
}

/**
 * Check if a given object implements the PaginatedCalvinUserList interface.
 */
export function instanceOfPaginatedCalvinUserList(value: object): value is PaginatedCalvinUserList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedCalvinUserListFromJSON(json: any): PaginatedCalvinUserList {
  return PaginatedCalvinUserListFromJSONTyped(json, false);
}

export function PaginatedCalvinUserListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedCalvinUserList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(CalvinUserFromJSON),
  };
}

export function PaginatedCalvinUserListToJSON(value?: PaginatedCalvinUserList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(CalvinUserToJSON),
  };
}
